import { deepPurple, pink, red } from '@mui/material/colors';
import './App.css';
import { MainRouter } from './Router';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import 'animate.css';

import { useState } from 'react';
import { AppContext } from './context/context';

const theme = createTheme({
  palette: {
    primary: {
      main: deepPurple[300],
    },
    secondary: {
      main: pink[200] 
    }
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'unu' },
          style: {
            backgroundColor: deepPurple[300],
            color: 'white',
            '&:hover': {
              backgroundColor: deepPurple[400],
            },
          }  
        },
        {
          props: { variant: 'unu-outlined' },
          style: {
            border: `1px solid ${deepPurple[200]}`,
            backgroundColor: '#fff',
            color: deepPurple[200],
            '&:hover': {
              backgroundColor: deepPurple[100],
              color: '#fff'
            },
          }  
        },
      ]
    },
    MuiInput: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            border: `1px solid ${ red[300] }`,
            borderRadius: 20,
            backgroundColor: '#fff'
          }
        }
      ]
    },
    MuiTextField: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            borderRadius: 20
          }
        }
      ]
    },
  },
});

export const initialDataState = {
  data: null,
  loading: false,
  error: null,
  errorMessage: '',
  code: 0,
  files: null
}
function App() {
  const [data, setData] = useState(initialDataState)
  return (
    <ThemeProvider theme={theme}>
      <AppContext.Provider value={{
        data, setData
      }}>
        <MainRouter />
      </AppContext.Provider>
    </ThemeProvider>
  );
}

export default App;
